import { ReactNode } from 'react';
import { useLazySection } from '@/hooks/useLazySection';
import { Skeleton } from '@/components/ui/skeleton';

interface LazySectionProps {
  children: ReactNode;
  className?: string;
  fallbackHeight?: string;
  rootMargin?: string;
}

export function LazySection({ 
  children, 
  className = '', 
  fallbackHeight = '400px',
  rootMargin = '200px'
}: LazySectionProps) {
  const [ref, isVisible] = useLazySection({ rootMargin });

  return (
    <div ref={ref} className={className}>
      {isVisible ? (
        children
      ) : (
        <div 
          style={{ minHeight: fallbackHeight }} 
          className="flex items-center justify-center"
        >
          <div className="w-full max-w-4xl mx-auto px-4 space-y-4">
            <Skeleton className="h-8 w-48 mx-auto" />
            <Skeleton className="h-4 w-64 mx-auto" />
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-8">
              <Skeleton className="h-48 rounded-lg" />
              <Skeleton className="h-48 rounded-lg" />
              <Skeleton className="h-48 rounded-lg hidden lg:block" />
              <Skeleton className="h-48 rounded-lg hidden lg:block" />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
